import React, { useState } from "react";
import Button from "components/BaseWidgets/button";
import { PremiumIcon } from "assets/icons";
import "./style.scss";
import GoPremiumModal from "../goPremiumModal";
import { useNavigate } from "react-router-dom";

function GoPremiumCard({
  title = "To unlock contact number & email ID",
  buttonText = " Go premium now",
  className,
  outlineBlur,
  premiumIcon,
  redirect = false,
}) {
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const handleCancel = () => {
    setOpenModal(false);
  };

  const handleClick = () => {
    navigate("/plans");
  };

  return (
    <>
      <div
        className={`${outlineBlur ? "outline-blur" : ""} ${className ? className : ""}`}
      >
        <div className="premium-upgrade-frame">
          {outlineBlur || premiumIcon ? (
            <span className="premium-icon">
              <PremiumIcon />
            </span>
          ) : null}
          <div className="upgrade-content flex flex-col justify-center items-center gap-2">
            <span className="title">{title}</span>
            <Button
              className={`go-premium-btn`}
              onClick={handleClick}
              icon={<PremiumIcon />}
            >
              {buttonText}
            </Button>
          </div>
        </div>

        {!redirect && (
          <GoPremiumModal
            open={openModal}
            wrapClassName={`go-premium-primary`}
            contentTitle={"To unlock more features"}
            buttonTitle={"Go premium now"}
            onCancel={handleCancel}
            onOk={() => setOpenModal(false)}
            title="Congratulations, you are now registered."
            description="Now, let's complete your profile."
          />
        )}
      </div>
    </>
  );
}

export default GoPremiumCard;
